// extracted by mini-css-extract-plugin
module.exports = {"statement":"_3bO1y"};